<template>
  <div class="grid-view">
    <div class="main-content entry-summary-rule">
      <div class="section operations">
        <div class="filters">
          <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" :disabled="!selectedRow" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
          <el-button type="danger" :disabled="!selectedRow" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
          <el-button type="primary" @click="editSummarySeparatorHandler">{{ $t('FinanceManage.SeparatorSettings') }}</el-button>
          <el-checkbox v-if="enableSummaryDimensionOrder" v-model="accountSet.exportSeparator" style="padding-left: 10px;" @change="exportSeparatorSeparatorSaveHandler">{{ $t('FinanceManage.ExportSeparator') }}</el-checkbox>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
      <!--新增/编辑-->
      <summary-rule-selector-dialog
        :visible.sync="summaryRuleSelectorDialog.visible"
        :account-set="accountSet"
        :entry-summary-rule="summaryRuleSelectorDialog.entrySummaryRule"
        :enable-summary-dimension-order="enableSummaryDimensionOrder"
        @saveHandler="saveHandler"
      />
      <!--分隔符设置-->
      <el-dialog
        :visible.sync="summarySeparatorDialog.visible"
        :title="$t('FinanceManage.SeparatorSettings')"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="380px"
      >
        <el-form label-width="90px">
          <el-form-item :label="$t('FinanceManage.Separator')">
            <el-input v-model="summarySeparatorDialog.summarySeparator" style="width: 200px;" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="summarySeparatorSaveHandler">{{ $t('common.btn.save') }}</el-button>
          <el-button @click="summarySeparatorDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import SummaryRuleSelectorDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/SummaryRuleSelectorDialog'
import { getLoading } from '@/utils/utilBaseElement'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as entrySummaryRuleApi from '@/api/financeManage/entrySummaryRule'
import * as accountSetApi from '@/api/financeManage/accountSet'
import FinanceUtil from '@/utils/FinanceUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { sortByMultiField } from '@/utils'

export default {
  name: 'EntrySummaryMapping',
  components: { SummaryRuleSelectorDialog },
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      selectedRow: null, // 是否选中行
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: this.onRowClickedHandler
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_GroupingType'),
          field: 'businessDataType',
          width: 120,
          cellRenderer: params => {
            return FinanceUtil.businessDataTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_JournalEntryCategory'),
          field: 'entryType',
          width: 150,
          cellRenderer: params => {
            return FinanceUtil.entryTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GroupingConditions'),
          field: '',
          width: 300,
          cellRenderer: params => {
            return this.summaryDimensionLabelFunc(params.data) || ''
          }
        }],
      rowData: [],
      locked: true,
      summarySeparatorDialog: {
        visible: false,
        summarySeparator: ''
      },
      summaryRuleSelectorDialog: {
        visible: false,
        entrySummaryRule: {}
      },
      enableSummaryDimensionOrder: false
    }
  },
  computed: {
    accountSetUuid() {
      return this.accountSet.uuid
    }
  },
  watch: {
    accountSetUuid() {
      this.loadRules()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.enableSummaryDimensionOrder = Number(cache.config.get('enableSummaryDimensionOrder')) === 1
    // 加载列表
    this.loadRules()
  },
  methods: {
    loadRules() {
      const loading = getLoading()
      const params = {}
      params.accountSetUuid = this.accountSet.uuid
      entrySummaryRuleApi.query(params).then(resp => {
        this.rowData = resp.data.list
        this.accountSet.entrySummaryRule = resp.data.list
        this.gridOptions.api.refreshCells({ force: true })
      }).catch(() => {
        this.rowData = []
        this.gridOptions.api.refreshCells({ force: true })
      }).finally(() => loading.close())
      this.gridOptions.api.clearFocusedCell()
      this.selectedRow = null
    },
    addHandler() {
      const rule = {}
      rule.businessDataType = 0
      rule.entryType = 0
      rule.defaultSummary = ''
      rule.entrySummaryDimension = []
      this.summaryRuleSelectorDialog.entrySummaryRule = rule
      this.summaryRuleSelectorDialog.visible = true
    },
    async editHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedRow : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const rule = await entrySummaryRuleApi.detail({ uuid: currentRow.uuid }).then(resp => resp.data)
      this.summaryRuleSelectorDialog.entrySummaryRule = rule
      this.summaryRuleSelectorDialog.visible = true
    },
    saveHandler(entrySummaryRule) {
      // 保存
      const loading = getLoading()
      entrySummaryRuleApi.save(entrySummaryRule).then(resp => {
        this.saveSuccess(resp)
        this.summaryRuleSelectorDialog.visible = false
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      }).finally(() => loading.close())
    },
    cancelHandler() {
      this.locked = true
      this.loadRules()
    },
    refreshHandler() {
      this.loadRules()
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedRow : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToDeleteTheRule'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading()
      entrySummaryRuleApi.remove({ uuid: currentRow.uuid }).then(resp => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    saveSuccess(resp) {
      // 返回的列表中可能同时含有编辑的和新增的数据
      const data = resp.data
      if (!data) return
      const index = this.rowData.findIndex(params => params.uuid === data.uuid)
      if (index > -1) {
        Object.assign(this.rowData[index], data)
      } else {
        this.rowData.push(data)
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    summaryDimensionLabelFunc(entrySummaryRule) {
      let labels = []
      if (entrySummaryRule.defaultSummary) {
        labels.push({ 'summary': entrySummaryRule.defaultSummary, 'sequenceNo': entrySummaryRule.sequenceNo })
      }
      if (entrySummaryRule.secondSummary) {
        labels.push({ 'summary': entrySummaryRule.secondSummary, 'sequenceNo': entrySummaryRule.secondSequenceNo })
      }
      for (const entrySummaryDimension of entrySummaryRule.entrySummaryDimension) {
        const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_GROUPING_DIMENSIONS, entrySummaryDimension.dimension)
        if (state) {
          labels.push({ 'summary': state.chineseName, 'sequenceNo': entrySummaryDimension.sequenceNo })
        }
      }
      labels = sortByMultiField(labels, ['sequenceNo'], false)
      const summarys = []
      if (labels) {
        for (const label of labels) {
          summarys.push(label.summary)
        }
      }
      return summarys.join('-')
    },
    async editSummarySeparatorHandler() {
      this.summarySeparatorDialog.summarySeparator = this.accountSet.summarySeparator
      this.summarySeparatorDialog.visible = true
    },
    async summarySeparatorSaveHandler() {
      const accountSet = await accountSetApi.detail({ uuid: this.accountSet.uuid }).then(resp => resp.data)
      accountSet.summarySeparator = this.summarySeparatorDialog.summarySeparator
      const loading = getLoading('app-main-content')
      accountSetApi.save(accountSet).then(resp => {
        this.summarySeparatorDialog.visible = false
        this.accountSet.summarySeparator = resp.data.summarySeparator
        // todo 父组件处理事件
        this.$emit('loadAccountSet', resp.data)
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).finally(() => loading.close())
    },
    onRowClickedHandler(event) {
      this.selectedRow = event.data
    },
    exportSeparatorSeparatorSaveHandler() {
      if (!this.accountSet.uuid) return
      const loading = getLoading('app-main-content')
      accountSetApi.saveAccountSetField(this.accountSet).then(resp => {
        const res = resp.data
        if (res) {
          this.accountSet.version = res.version
        }
      }).finally(() => loading.close())
    }
  }
}
</script>

<style scoped>

</style>
